import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { io } from 'socket.io-client'
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';

export const IO = io(process.env.REACT_APP_API_URL);

ReactDOM.render(
  (
    <Provider store={store}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </Provider>
  ),
  document.getElementById('root')
);
